import {
  Whatshot,
  AcUnit,
  WbSunny,
  NewReleases,
  Forum,
  Schedule,
  Phone,
  PhoneMissed,
  PhoneCallback,
  PauseCircle,
  Replay,
  RemoveCircle,
  Block,
  LabelImportant,
  HelpOutline,
  ErrorOutline,
  Timer,
  NotificationsNone,
  TrendingUp,
  TrendingDown,
  VisibilityOff,
  ThumbUp,
  ThumbDown,
  WarningAmber,
  QuestionMark,
  AssignmentLate,
  AssignmentReturned,
  AssignmentTurnedIn,
} from "@mui/icons-material";
import { Crown, Heart, Droplets, Sprout } from "lucide-react";

import {
  Moon,
  Sparkles,
  Droplet,
  Leaf,
  Sun,
  Shield,
  Layers,
} from "lucide-react";

export const GRADE_STATUS_UI_MAP = {
  new: { color: "#0051FF", icon: <NewReleases fontSize="small" /> },

  cold: { color: "#007A99", icon: <AcUnit fontSize="small" /> },
  warm: { color: "#C48F00", icon: <WbSunny fontSize="small" /> },
  hot: { color: "#D40000", icon: <Whatshot fontSize="small" /> },

  contacted: { color: "#2563EB", icon: <Phone fontSize="small" /> },
  unreachable: { color: "#6B7280", icon: <PhoneMissed fontSize="small" /> },
  callback: { color: "#7C3AED", icon: <PhoneCallback fontSize="small" /> },

  interested: { color: "#16A34A", icon: <Forum fontSize="small" /> },
  notinterested: { color: "#9CA3AF", icon: <ThumbDown fontSize="small" /> },

  followup: { color: "#F97316", icon: <Schedule fontSize="small" /> },
  followuplater: { color: "#FB923C", icon: <Timer fontSize="small" /> },
  followupmissed: {
    color: "#DC2626",
    icon: <AssignmentLate fontSize="small" />,
  },

  pending: { color: "#F59E0B", icon: <PauseCircle fontSize="small" /> },
  retry: { color: "#7C3AED", icon: <Replay fontSize="small" /> },
  waiting: { color: "#FACC15", icon: <Timer fontSize="small" /> },

  busy: { color: "#6B7280", icon: <PauseCircle fontSize="small" /> },
  switchedoff: { color: "#9CA3AF", icon: <VisibilityOff fontSize="small" /> },
  ringing: { color: "#0EA5E9", icon: <NotificationsNone fontSize="small" /> },

  positive: { color: "#22C55E", icon: <ThumbUp fontSize="small" /> },
  negative: { color: "#EF4444", icon: <ThumbDown fontSize="small" /> },
  neutral: { color: "#A1A1AA", icon: <HelpOutline fontSize="small" /> },

  unqualified: { color: "#EF4444", icon: <TrendingDown fontSize="small" /> },

  duplicate: { color: "#9CA3AF", icon: <Block fontSize="small" /> },
  duplicatelead: { color: "#9CA3AF", icon: <Block fontSize="small" /> },
  invalid: { color: "#6B7280", icon: <ErrorOutline fontSize="small" /> },
  blocked: { color: "#991B1B", icon: <Block fontSize="small" /> },
  spam: { color: "#991B1B", icon: <Block fontSize="small" /> },

  dropped: { color: "#4A4A4A", icon: <RemoveCircle fontSize="small" /> },
  abandoned: { color: "#525252", icon: <RemoveCircle fontSize="small" /> },
  expired: { color: "#7C2D12", icon: <AssignmentReturned fontSize="small" /> },

  enquiryonly: { color: "#0EA5E9", icon: <QuestionMark fontSize="small" /> },
  pricerequested: {
    color: "#0284C7",
    icon: <LabelImportant fontSize="small" />,
  },
  comparing: { color: "#6366F1", icon: <HelpOutline fontSize="small" /> },

  highintent: { color: "#16A34A", icon: <TrendingUp fontSize="small" /> },
  lowintent: { color: "#9CA3AF", icon: <TrendingDown fontSize="small" /> },

  verified: { color: "#059669", icon: <AssignmentTurnedIn fontSize="small" /> },
  unverified: { color: "#F59E0B", icon: <WarningAmber fontSize="small" /> },

  rescheduled: { color: "#D97706", icon: <Replay fontSize="small" /> },
  deferred: { color: "#A855F7", icon: <PauseCircle fontSize="small" /> },

  languageissue: { color: "#6B7280", icon: <ErrorOutline fontSize="small" /> },
  wrongnumber: { color: "#DC2626", icon: <PhoneMissed fontSize="small" /> },
  voicemail: { color: "#64748B", icon: <PhoneMissed fontSize="small" /> },

  testlead: { color: "#94A3B8", icon: <HelpOutline fontSize="small" /> },
  internal: { color: "#475569", icon: <LabelImportant fontSize="small" /> },
  referral: { color: "#22C55E", icon: <ThumbUp fontSize="small" /> },
};

export const LOCKED_GRADE_STATUSES = ["new"];

export const GRADE_STATUS_GROUPS = {
  // Lead Stage - Grade Type
  Leads: ["new", "cold", "warm", "hot", "dropped"],

  "Call Outcome": [
    "contacted",
    "unreachable",
    "callback",
    "busy",
    "switchedoff",
    "ringing",
    "voicemail",
    "wrongnumber",
  ],

  "Interest Level": [
    "interested",
    "notinterested",
    "positive",
    "negative",
    "neutral",
    "highintent",
    "lowintent",
  ],

  "Follow Up": [
    "followup",
    "followuplater",
    "followupmissed",
    "retry",
    "rescheduled",
    "deferred",
    "waiting",
  ],

  Verification: ["verified", "unverified"],

  "Lead Quality": [
    "duplicate",
    "duplicatelead",
    "invalid",
    "unqualified",
    "blocked",
    "spam",
    "testlead",
    "internal",
  ],

  "Dropped / Closed": ["dropped", "abandoned", "expired"],

  Enquiry: ["enquiryonly", "pricerequested", "comparing"],
};

export const GRADE_STATUSES = Object.keys(GRADE_STATUS_UI_MAP);

export const fallbackColor = (key) => {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${hash % 360}, 65%, 45%)`;
};

export const getStatusUI = (key) =>
  GRADE_STATUS_UI_MAP[key] || {
    color: fallbackColor(key),
    icon: <LabelImportant fontSize="small" />,
  };

export const capitalize = (key) =>
  key
    .replace(/followup/g, "follow up")
    .replace(/notinterested/g, "not interested")
    .replace(/highintent/g, "high intent")
    .replace(/lowintent/g, "low intent")
    .replace(/pricerequested/g, "price requested")
    .replace(/wrongnumber/g, "wrong number")
    .replace(/duplicatelead/g, "duplicate lead")
    .replace(/switchedoff/g, "switched off")
    .replace(/languageissue/g, "language issue")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const THEME_OPTIONS = [
  {
    key: "dark_purple",
    label: "Dark Purple",
    icon: <Moon size={16} />,
    color: "#A855F7",
  },
  {
    key: "dark_neo",
    label: "Neo Dark",
    icon: <Sparkles size={16} />,
    color: "#22D3EE",
  },
  {
    key: "dark_ocean",
    label: "Dark Ocean",
    icon: <Droplet size={16} />,
    color: "#0EA5E9",
  },
  {
    key: "dark_forest",
    label: "Dark Forest",
    icon: <Leaf size={16} />,
    color: "#16A34A",
  },
  {
    key: "dark_sunset",
    label: "Dark Sunset",
    icon: <Sun size={16} />,
    color: "#F97316",
  },

  {
    key: "dark_blue",
    label: "Dark Blue",
    icon: <Sun size={16} />,
    color: "#2563EB",
  },

  {
    key: "dark_red",
    label: "Dark Red",
    icon: <Whatshot size={16} />,
    color: "#DC2626",
  },
  {
    key: "dark_orange",
    label: "Dark Orange",
    icon: <Sun size={16} />,
    color: "#EA580C",
  },
  {
    key: "dark_teal",
    label: "Dark Teal",
    icon: <Droplet size={16} />,
    color: "#0D9488",
  },
  {
    key: "dark_indigo",
    label: "Dark Indigo",
    icon: <Moon size={16} />,
    color: "#4F46E5",
  },
  {
    key: "dark_gray",
    label: "Dark Gray",
    icon: <Layers size={16} />,
    color: "#6B7280",
  },
  {
    key: "dark_gold",
    label: "Dark Gold",
    icon: <Crown size={16} />,
    color: "#FACC15",
  },
  {
    key: "dark_rose",
    label: "Dark Rose",
    icon: <Heart size={16} />,
    color: "#E11D48",
  },

  {
    key: "dark_lime",
    label: "Dark Lime",
    icon: <Sprout size={16} />,
    color: "#84CC16",
  },
  {
    key: "dark_black",
    label: "Pure Black",
    icon: <Moon size={16} />,
    color: "#000000",
  },
];
